export default {
  location: 'https://ocdsanalytics.com/ua/prozorro/graphql',
  apiKey: '591f3eb12295f514849f655e2069eeeec48269b5',
}
